import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { ButtonOutline } from "components/ui/buttons/ButtonOutline/ButtonOutline"
import { ButtonDanger } from "components/ui/buttons/ButtonDanger/ButtonDanger"
import { Tooltip } from "components/ui/tooltip/Tooltip"
import style from "./FurnitureFooter.module.scss"

const { footer, buttons, addButton, unReviewButton, removeButton } = style

type Props = {
	isReviewed: boolean
	isInQuotation: boolean
	isPending: boolean
	onToggleReviewed: () => void
	canAddToQuotation: boolean
	onAddToQuotation: () => void
	onRemoveFromQuotation: () => void
	/**
	 * Hides the review / unreview button, leaving only "Add to quotation". The batch panel (REQ-403)
	 * turns it off for a selection whose objects do NOT share one review state: the toggle sends one
	 * status to all of them, so with a mixed selection either label would be a lie — and "Mark as
	 * reviewed" would silently pull any `in_quotation` object back out of the quotation. Defaults to
	 * on, so the single-object sidebar is unaffected (one object always has exactly one status).
	 */
	showReviewToggle?: boolean
}

export const FurnitureFooter = ({
	isReviewed,
	isInQuotation,
	isPending,
	onToggleReviewed,
	canAddToQuotation,
	onAddToQuotation,
	onRemoveFromQuotation,
	showReviewToggle = true,
}: Props) => {
	const addButtonNode = (
		<ButtonPrimary
			variant="success"
			className={addButton}
			submittable={canAddToQuotation && !isPending}
			onClick={onAddToQuotation}
		>
			Add to quotation
		</ButtonPrimary>
	)

	return (
		<div className={footer}>
			{isInQuotation ? (
				<ButtonDanger className={removeButton} submittable={!isPending} onClick={onRemoveFromQuotation}>
					Remove from quotation
				</ButtonDanger>
			) : (
				<div className={buttons}>
					{!showReviewToggle ? null : isReviewed ? (
						<ButtonDanger className={unReviewButton} submittable={!isPending} onClick={onToggleReviewed}>
							Mark as unreviewed
						</ButtonDanger>
					) : (
						<ButtonOutline submittable={!isPending} onClick={onToggleReviewed}>
							Mark as reviewed
						</ButtonOutline>
					)}
					{canAddToQuotation ? (
						addButtonNode
					) : (
						<Tooltip text="Fill in all required fields to add to quotation" placement="top">
							<span className={addButton}>{addButtonNode}</span>
						</Tooltip>
					)}
				</div>
			)}
		</div>
	)
}
